module.exports = __webpack_public_path__ + "static/img/product1-3.999c92e5.png";